<div class="avatar">
    <div class="avatar-text">
        <app-text [text]="title" type="h5" colorClass="color-gray-300" [fontSize]="16" [lineHeight]="26" fontWeight="600" [customStyles]="{ fontStyle: 'normal', textAlign: 'end' }"></app-text>
        <app-text [text]="subtitle" type="h6" colorClass="color-secondary-500" [fontSize]="12" [lineHeight]="16" fontWeight="400" [customStyles]="{ fontStyle: 'normal', textAlign: 'end' }"></app-text>
    </div>
    <div class="avatar-image" *ngIf="image">
        <img [src]="image" [alt]="title" (error)="onMissingImage($event)" />
    </div>
    <div class="avatar-user-name" *ngIf="!image">
        <p class="user-name">{{ avatarName }}</p>
    </div>
</div>